import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import { LoginModule } from '@blade/common/store/login';
import { getAttributes } from '@blade-sxp/search-center/api/index';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import deviceSelect from '@blade-sxp/search-center/pages/components/result/attrbutes-cascader-select/index.vue';
let Device = class Device extends Vue {
    featureList;
    activeName = this.$t('face');
    permissons = [];
    facePermissonEnable = false;
    bodyPermissonEnable = false;
    vehiclePermissonEnable = false;
    langeName = false;
    attributesList;
    attributesOptions = [];
    attributesObj = {};
    tabList = [];
    emitPath = true;
    mounted() {
        this.init();
    }
    // 根据搜索返回获取有数据的tablist 权限排除 非空排除
    getTabList(updateSearchList) {
        let searchList = updateSearchList || this.$route.query?.list?.searchList;
        let type = this.$route.query?.type;
        this.tabList = searchList
            ?.map((item) => {
            return {
                chineseName: item.chineseName,
                list: item.list,
                trackName: item.trackName,
                trackType: item.trackType,
                enable: item.trackType === 'OBJECT_FACE'
                    ? this.facePermissonEnable
                    : item.trackType === 'OBJECT_PEDESTRIAN'
                        ? this.bodyPermissonEnable
                        : this.vehiclePermissonEnable,
            };
        })
            ?.filter((item) => item.enable);
        if (type !== 'features') {
            this.tabList = this.tabList?.filter((item) => item.list.length > 0);
        }
    }
    init() {
        searchCenterStore.updateActiveName(this.activeName);
        this.permissons = LoginModule.permissions || [];
        const language = localStorage.getItem('language');
        if (language === 'zh') {
            this.langeName = false;
        }
        else if (language === 'en-us') {
            this.langeName = true;
        }
        this.getPermission();
        this.getTabList();
        // 获取属性接口
        getAttributes().then((res) => {
            this.attributesList = res;
            if (searchCenterStore.featureType === 'OBJECT_FACE') {
                this.attributesOptions = this.getAttributesFormat(res.faceAttributes);
            }
            else if (searchCenterStore.featureType === 'OBJECT_PEDESTRIAN') {
                this.attributesOptions = this.getAttributesFormat(res.pedestrianAttributes);
            }
            else {
                this.attributesOptions = this.getAttributesFormat(res.vehicleAttributes);
            }
        });
    }
    onTabListChange() {
        if (this.tabList?.length) {
            searchCenterStore.updateFeatureType(this.tabList[0]?.trackType);
        }
    }
    onActiveNameChange(str) {
        searchCenterStore.updateActiveName(str);
    }
    // 获取人脸,身体,车辆任务权限list
    getPermission() {
        this.permissons = LoginModule.permissions || [];
        let permissionCard;
        // 获取任务管理子权限
        permissionCard = this.permissons.filter((item) => item?.code === '03')[0]?.subPermissions;
        // 人脸权限
        this.facePermissonEnable = permissionCard.filter((item) => item?.code === '0302')[0]?.enable;
        // 人体权限
        this.bodyPermissonEnable = permissionCard.filter((item) => item?.code === '0303')[0]?.enable;
        // 车辆权限
        this.vehiclePermissonEnable = permissionCard.filter((item) => item?.code === '0304')[0]?.enable;
    }
    // tab点击
    handleClick() {
        this.attributesObj = {};
        let featureTypeArr = this.tabList.filter((item) => item.chineseName === this.activeName || item.trackName === this.activeName); // any todo
        searchCenterStore.updateFeatureType(featureTypeArr[0]?.trackType);
        if (this.activeName === this.$t('face')) {
            this.attributesOptions = this.getAttributesFormat(this.attributesList.faceAttributes);
            this.$parent.changeTabIndex(0);
        }
        else if (this.activeName === this.$t('body')) {
            this.attributesOptions = this.getAttributesFormat(this.attributesList.pedestrianAttributes);
            this.$parent.changeTabIndex(1);
        }
        else {
            this.$parent.changeTabIndex(2);
            this.attributesOptions = this.getAttributesFormat(this.attributesList.vehicleAttributes);
        }
    }
    onAttributesObjchange(val) {
        // 处理成后端需要的格式
        let attributeMaps = {}; // 属性值不固定
        if (val.length) {
            val?.forEach((element) => {
                attributeMaps[element[0]] = [];
            });
            for (let attrbuteName in attributeMaps) {
                val?.forEach((element, index) => {
                    if (attrbuteName === element[0]) {
                        val[index]?.forEach((item, itemIndex) => {
                            if (itemIndex !== 0) {
                                attributeMaps[attrbuteName]?.push(item);
                            }
                        });
                    }
                });
            }
        }
        searchCenterStore.updateAttributeMaps(attributeMaps);
    }
    // 属性list格式化
    getAttributesFormat(arr) {
        let attybutesOptions = [];
        arr?.forEach((e) => {
            attybutesOptions.push({
                value: e.key,
                label: !this.langeName ? e.chineseName : e.englishName,
                children: e.values?.map((child) => {
                    return {
                        value: child.valueKey,
                        label: !this.langeName ? child.chineseName : child.englishName,
                    };
                }),
            });
        });
        return attybutesOptions;
    }
};
__decorate([
    Prop()
], Device.prototype, "featureList", void 0);
__decorate([
    Watch('tabList', { deep: true })
], Device.prototype, "onTabListChange", null);
__decorate([
    Watch('activeName', { deep: true })
], Device.prototype, "onActiveNameChange", null);
__decorate([
    Watch('attributesObj', { deep: true })
], Device.prototype, "onAttributesObjchange", null);
Device = __decorate([
    Component({
        name: 'propertyRetrieval',
        components: { deviceSelect },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Device);
export default Device;
